export class Widget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WidgetType",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "layout",
            "baseName": "layout",
            "type": "WidgetLayout",
            "format": ""
        },
        {
            "name": "field",
            "baseName": "field",
            "type": "FieldConfig",
            "format": ""
        },
        {
            "name": "stat",
            "baseName": "stat",
            "type": "StatWidget",
            "format": ""
        },
        {
            "name": "timeseries",
            "baseName": "timeseries",
            "type": "TimeseriesWidget",
            "format": ""
        },
        {
            "name": "table",
            "baseName": "table",
            "type": "TableWidget",
            "format": ""
        },
        {
            "name": "stateList",
            "baseName": "stateList",
            "type": "StateListWidget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Widget.attributeTypeMap;
    }
    constructor() {
    }
}
